import { render } from "./Layout.vue?vue&type=template&id=1df6691d"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=1df6691d&lang=less"
script.render = render

export default script